'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailabilityAwayMessage = undefined;

var _reselect = require('reselect');

var _availabilityConfigGetters = require('conversations-schema/availability/operators/config/availabilityConfigGetters');

var _getWidgetAvailabilityOptions = require('./getWidgetAvailabilityOptions');

var getAvailabilityAwayMessage = exports.getAvailabilityAwayMessage = (0, _reselect.createSelector)([_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions], function (availabilityOptions) {
  return (0, _availabilityConfigGetters.getAwayMessage)(availabilityOptions) || '';
});